module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.93989831.svg";